import React, { useRef, useState } from 'react';
import { useParams } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";

import LoginService from "../service/LoginService";
import UserService from "../service/UsuarioService";

const loginService = new LoginService(); // Create an instance of LoginService
const userService = new UserService(); // Create an instance of LoginService

export const NewPassword = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const history = useHistory();

    const handleLogin = async () => {
        try {
            const data = { password };

            setLoading(true)

            const newPwd = await loginService.reset(props.verifyToken, data);

            if (newPwd.status === 200) {

                const data = { email: newPwd.data.message.login, password };

                setLoading(true)

                const userData = await loginService.login(data);

                if (userData.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Login efetuado com sucesso!', detail: 'redirecionando...', life: 3000 });
                    localStorage.setItem('token', userData.data.jwt.token);
                    localStorage.setItem('iss', userData.data.jwt.iss);

                    const profileData = await userService.getMe(userData.data.jwt.iss); // Call the user get me method
                    localStorage.setItem('profile', JSON.stringify(profileData.data.data));
                    localStorage.setItem('idUser', profileData.data.data.profile.user_id);
                    localStorage.setItem('idEmpresa', profileData.data.data.companies[0].id);
                    if (profileData.data.data.prestador)
                        localStorage.setItem('idPrestador', profileData.data.data.prestador.id);
                    localStorage.setItem('nomeEmpresa', profileData.data.data.companies[0].name);

                    const roles = {};

                    const admin = profileData.data.data.role.name === 'Administrador' ? true : false

                    profileData.data.data.role.permissions.forEach(e => {
                        var attr = e.route;
                        if (attr.search('list') >= 0) roles["grupoCadastro"] = true;
                        if (admin) { roles["admin"] = admin } else { roles[profileData.data.data.role.name] = true };
                        roles[attr] = true;
                    });

                    localStorage.setItem('roles', JSON.stringify(roles));

                    setTimeout(() => {
                        history.push('/');
                    }, 1000)
                }

                setLoading(false)


            }
            // Handle successful login, such as updating state or navigating to another page
        } catch (error) {
            // Handle login error, such as displaying an error message to the user
            setLoading(false)
            if (error.status === 401) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Erro ao fazer login. Token Inválido.' });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Erro ao fazer login' });
            }
            console.error('Login error:', error);
        }
    };

    return (
        <div className="login-body">
            <Toast ref={toast} />
            <div style={{ width: '30%' }} className="login-image">

            </div>
            <div className="login-panel p-fluid">
                <div className="flex flex-column">
                    <div className="flex align-items-center mb-6 logo-container">
                        <h1>StarBlack</h1>
                    </div>
                    <div className="form-container">
                        {/* <span className="p-input-icon-left">
                            <i className="pi pi-envelope"></i>
                            <InputText value={email} onChange={(e) => setEmail(e.target.value)} type="text" placeholder="Email" />
                        </span> */}
                        <span className="p-input-icon-left">
                            <i className="pi pi-key"></i>
                            <InputText value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Nova senha" />
                        </span>
                    </div>
                    <div className="button-container">
                        <Button loading={loading} onClick={handleLogin} type="button" label="Login"></Button>

                    </div>
                </div>

                <div className="login-footer flex align-items-center">
                    <div className="flex align-items-center login-footer-logo-container">
                        <h4>StarBlack</h4>
                    </div>
                    <span>Copyright 2024</span>
                </div>
            </div>
        </div>
    )
}
